import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType } from 'vue';
import BCXFormValues from '@/components/molecules/forms/BCXFormValues.vue';
import { BcxFormValueField } from '@/models/BcxForm';
import { useMyProjects } from '@/views/my-projects/composables/useMyProjects';
import { ComponentInvoice } from '@/models/Invoice';
import useUser from '@/mixins/useUser';
import useFormattedDateTime from '@/mixins/useFormattedDateTime';
import useCurrency from '@/mixins/useCurrency';


export default /*#__PURE__*/_defineComponent({
  __name: 'InvoiceIncomingExtendedRowBaseData',
  props: {
  invoice: {
    type: Object as PropType<ComponentInvoice>,
    default: null
  }
},
  setup(__props) {

const props = __props;



const { isNarrow } = useMyProjects();
const { tUserFallback: t } = useUser('self');
const { getFormattedDate } = useFormattedDateTime();
const { format: currencyFormat } = useCurrency();

const adjustedInvoice = computed(() => ({
  ...props.invoice,
  status: t(`invoice.status-options.${props.invoice.status}`),
  issueDate: getFormattedDate(props.invoice.issueDate),
  dueDate: getFormattedDate(props.invoice.dueDate),
  totalAmount: currencyFormat(props.invoice.totalAmount)
}));

const fields = computed(() => {
  const f = {
    status: { name: 'status', label: `${t('invoices.extended-row.invoice.status_USERTYPE')}` },
    bcReferenceId: { name: 'bcReferenceId', label: `${t('invoices.extended-row.invoice.bcReferenceId_USERTYPE')}` },
    issueDate: { name: 'issueDate', label: `${t('invoices.extended-row.invoice.issueDate_USERTYPE')}` },
    invoiceDocId: { name: 'invoiceDocId', label: `${t('invoices.extended-row.invoice.invoiceDocId_USERTYPE')}` },
    dueDate: { name: 'dueDate', label: `${t('invoices.extended-row.invoice.dueDate_USERTYPE')}` },
    costCenter: { name: 'costCenter', label: `${t('invoices.extended-row.invoice.costCenter_USERTYPE')}` },
    totalAmount: { name: 'totalAmount', label: `${t('invoices.extended-row.invoice.totalAmount_USERTYPE')}` },
    contractBytecookieId: { name: 'contractBytecookieId', label: `${t('invoices.extended-row.invoice.contractBytecookieId_USERTYPE')}` },
    reference: { name: 'reference', label: `${t('invoices.extended-row.invoice.reference_USERTYPE')}` }
  };

  const fields: BcxFormValueField[] = isNarrow.value ? [
    // mobile order
    { ...f.status, width: '50%' },
    { ...f.bcReferenceId, width: '50%' },

    { ...f.issueDate, width: '50%' },
    { ...f.invoiceDocId, width: '50%' },

    { ...f.dueDate, width: '50%' },
    { ...f.costCenter, width: '50%' },

    { ...f.totalAmount, width: '50%' },
    { ...f.contractBytecookieId, width: '50%' },

    { ...f.reference, width: '100%' }
  ] : [
    // desktop order
    { ...f.status, width: '25%' },
    { ...f.bcReferenceId, width: '25%' },
    { ...f.dueDate, width: '50%' },

    { ...f.totalAmount, width: '25%' },
    { ...f.issueDate, width: '25%' },
    { ...f.invoiceDocId, width: '25%' },
    { ...f.costCenter, width: '25%' },

    { ...f.contractBytecookieId, width: '25%' },
    { ...f.reference, width: '75%' }
  ];

  return fields;
});

const getStatusClass = (fieldName: string): string => {
  if (fieldName !== 'status' || !props.invoice) {
    return '';
  }

  const { status } = props.invoice;

  if (status === 'DUE' || status === 'OVERDUE') {
    return 'c-status--due-overdue';
  }

  if (status === 'PAID') {
    return 'c-status--paid';
  }

  return '';
};

const extendValue = (fieldName: string, value: string) => {
  if (fieldName === 'totalAmount') {
    return `${value} ${t(`invoice.positions.form.currencyAbbreviation.${props.invoice.currency}`)}`;
  }
  return value;
};

return { __sfc: true,props, isNarrow, t, getFormattedDate, currencyFormat, adjustedInvoice, fields, getStatusClass, extendValue, BCXFormValues }
}

})